import React from 'react';
import { Box, Typography, InputLabel, Switch } from '@mui/material';
import slugify from 'slugify';

interface Props {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  label: string;
  handleChange: (value: boolean) => void;
  helperText?: string;
  value: boolean;
}

const Toggle: React.FC<Props> = (
  {
    className, disabled, error, helperText, label, handleChange, value,
  }: Props,
) => (
  <>
    <Box
      className={className}
      sx={{ columnGap: '0.5rem', display: 'flex', alignItems: 'center', flexGrow: 1, flexWrap: 'wrap' }}
    >
      <InputLabel htmlFor={slugify(label)}>{label}</InputLabel>
      <Typography
        sx={{ flexGrow: 1, fontStyle: 'italic', position: 'relative', top: '0.125rem', '&:hover': { cursor: 'pointer' } }}
        onClick={() => handleChange(!value)}
      >
        {value ? 'Yes' : 'No'}
      </Typography>
      <Switch
        checked={value}
        disabled={disabled}
        onChange={() => handleChange(!value)}
        color="primary"
        id={slugify(label)}
      />

      {helperText && (
        <Typography
          className={`MuiFormHelperText-root ${error ? 'Mui-error' : ''}`}
          sx={{ width: '100%' }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  </>
);

export default Toggle;
